<div class="further-insured-limits"
     data-test="further-insured-limits"
>
  <div class="hidden md:block">
    <p-table data-test="further-insured-limits-table"
             scrollHeight="60vh"
             [loading]="loading()"
             [scrollable]="true"
             [value]="rows"
    >
      <ng-template #header>
        <tr>
          <th id="further-insured-limits-title"
              pFrozenColumn
          >Further Insured
          </th>
          @for (column of columns(); track column.insured.company) {
            <th class="limit-value"
                [id]="'further-insured-limits-company-' + column.insured.company "
            >
              <span data-test="further-insured-limits-company">{{ column.insured.company }}</span>
              <ng-container *ngTemplateOutlet="policySelect; context: { $implicit: column }"/>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template #body
                   let-row
      >
        <tr [attr.data-test]="'further-insured-limits-row-' + row.key">
          <td class="limit-label"
              pFrozenColumn
              tooltipPosition="left"
              [pTooltip]="row.source"
          >{{ row.label }}
          </td>
          @for (column of columns(); track column.insured.company) {
            <td class="limit-value">{{ limitValue(column, row) }}</td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="flex flex-col gap-4 md:hidden"
       data-test="further-insured-limits-cards"
  >
    @for (column of columns(); track column.insured.company) {
      <div class="limits-card"
           data-test="further-insured-limits-card"
      >
        <p class="limits-card-title">{{ column.insured.company }}</p>
        <ng-container *ngTemplateOutlet="policySelect; context: { $implicit: column }"/>
        @for (row of rows; track row.key) {
          <div class="limits-card-row">
            <span tooltipPosition="top"
                  [pTooltip]="row.source"
            >{{ row.label }}</span>
            <span class="limit-value">{{ limitValue(column, row) }}</span>
          </div>
        }
      </div>
    }
    @if (loading()) {
      <i class="pi pi-spin pi-spinner self-center"></i>
    }
  </div>
</div>

<ng-template #policySelect
             let-column
>
  @if (column.policyOptions.length > 0) {
    <p-select appendTo="body"
              class="policy-select"
              data-test="further-insured-limits-policy"
              optionLabel="label"
              optionValue="value"
              placeholder="Select Policy"
              size="small"
              [disabled]="!editable()"
              [ngModel]="column.policyId"
              [options]="column.policyOptions"
              (ngModelChange)="onPolicyChange(column, $event)"
    />
  }
</ng-template>
